import React from 'react'

import { BookingDetailsProvider } from './context/BookingDetailsProvider'
import { BookingDetailsMain } from './components/BookingDetailsMain'

export const BookingDetails = ({
  bookingId,
  bookingIdx,
}: {
  bookingId: string
  bookingIdx: number
}) => {
  return (
    <BookingDetailsProvider bookingId={bookingId} bookingIdx={bookingIdx}>
      <BookingDetailsMain />
    </BookingDetailsProvider>
  )
}
